// The one apply CTA (COM-772) — renders the external application-form link
// with stored attribution already appended. The document-level handoff
// listener (lib/attribution.ts) fires the conversion, so this stays a plain
// link; per-CTA labels flow through data-apply-label.
import React from 'react';
import { APPLY_FORM_URL, withAttribution } from '../lib/attribution';

const ApplyLink: React.FC<{
  className?: string;
  /** Which CTA this is, e.g. "Hero Section Apply Now" — required so no apply
   *  link can reach production unlabelled (CMSY-18). */
  label: string;
  facilities?: number; // v2 facility id — preselects the kitchen on the form
  children: React.ReactNode;
}> = ({ className, label, facilities, children }) => (
  <a
    href={withAttribution(facilities ? `${APPLY_FORM_URL}?facilities=${facilities}` : APPLY_FORM_URL)}
    className={className}
    data-apply-label={label}
  >
    {children}
  </a>
);

export default ApplyLink;
